import React from 'react';
import styled from 'styled-components';
import { Metafields, Product } from '@/types/ecommerce.types';
import { withQueryOnlyData } from '../data/withQueryOnlyData';
import getProductDescriptionItems from '@/utils/getProductDescriptionItems';

const StyledHeader = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 2px;
  flex-wrap: wrap;
  text-align: center;

  @media (min-width: 800px) {
    font-size: 16px;
    width: 100%;
    margin-bottom: 0;
    justify-content: left;
    text-align: left;
  }
`;

const StyledList = styled.ul`
  list-style-type: none;
  display: flex;
`;

const StyledListItem = styled.li`
  margin: 5px 0;
  display: flex;
  align-items: center;

  &:not(:last-child)::after {
    content: '•';
    opacity: 0.5;
    margin: 0 3px;
  }
`;

const StyledNote = styled.div`
  flex-basis: 100%;
`;

const ProductInfoV2: React.FC<{
  product: Product;
  shopMetafields: Metafields;
  galleryTemplateIncld: string;
  productMaterial: string;
}> = ({ product, shopMetafields, galleryTemplateIncld, productMaterial }) => {
  if (!product) {
    return null;
  }

  return (
    <StyledHeader>
      <StyledList data-id={1}>
        {getProductDescriptionItems(product, shopMetafields).map((item) => (
          <StyledListItem key={item.key} data-cy={item.key}>
            {item.value}
          </StyledListItem>
        ))}
      </StyledList>
      {galleryTemplateIncld === 'false' && (
        <StyledNote>
          Hanging template NOT included with {productMaterial ? productMaterial : ''} variant
        </StyledNote>
      )}
    </StyledHeader>
  );
};

ProductInfoV2.displayName = 'ProductInfoV2';
export default withQueryOnlyData(ProductInfoV2);
